import integrationsClient, { type ApiDefinitions } from '@/tsClient/servers/governmentIntegrationsService';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinitions['/{provider}/creators/{creatorId}/submit-case']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const submitCase = async ({
  browserDriver,
  creatorId,
  district,
  documentIds,
  username,
  userWorkflowId,
  password,
  provider,
  useTestEnvironment,
  questionnaireId,
  skeleton,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/creators/{creatorId}/submit-case', { creatorId, provider });
  const response = await integrationsClient.post(path, {
    browserDriver,
    district,
    documentIds,
    password,
    questionnaireId,
    skeleton,
    useTestEnvironment,
    userWorkflowId,
    username,
  });
  return response.data;
};

export default submitCase;
